import { Component, input, inject } from '@angular/core';

import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-translated-text-display',
    template: `{{ getTranslatedValue() }}`,
    standalone: true,
    imports: [TranslateModule],
})
export class TranslatedTextDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    private translateService = inject(TranslateService);

    getTranslatedValue(): string {
        if (!this.value()) {
            return '';
        }

        // Use the same translation pattern as the old notifications component
        const translationKey =
            'OUTGOING-GOODS.NOTIFICATION-VIEW.TABLE-HEADER.TYPES.' + this.value();
        return this.translateService.instant(translationKey);
    }
}
